import { useEffect, useState } from 'react'
import { QueryStatus } from 'src/types'
import { HttpSistema } from '../api/httpSistema'
import { FileObjectWRC } from '../api/get-archivos'

export const useArchivos = (idOperacion: number, codSistema: number) => {
    const [archivos, setArchivos] = useState<FileObjectWRC[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpSistema.getArchivos(idOperacion, codSistema)
            .then(value => {
                setArchivos(value)
                setStatus(QueryStatus.Success)
            })
            .catch(() => {
                setStatus(QueryStatus.Error)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { archivos, refetch, status }
}
